const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

// Main registration function
export function register() {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) return;

    window.addEventListener('load', () => {
      // Force unregister old service workers first
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => {
          console.log('Unregistering old service worker');
          registration.unregister();
        });
        
        // Wait a bit then register the new one
        setTimeout(() => {
          const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
          isLocalhost ? checkValidServiceWorker(swUrl) : registerValidSW(swUrl);
        }, 1000);
      });
    });
  }
}

// Update notification handler (renamed from registerUpdateHandler)
export function onServiceWorkerUpdate() {
  return new Promise(resolve => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        resolve();
      });
    }
  });
}

// Private implementation - Using proven PWA pattern
function registerValidSW(swUrl) {
  console.log('🔄 Registering service worker:', swUrl);
  
  navigator.serviceWorker.register(swUrl)
    .then(registration => {
      console.log('✅ Service Worker registered successfully:', registration);
      
      // Add periodic update check (every minute)
      setInterval(() => {
        registration.update();
        console.log('🔍 Checked for service worker update...');
      }, 1000 * 60 * 1);
      
      // The critical piece - handle updates when new worker is found
      registration.onupdatefound = () => {
        console.log('🆕 Service Worker update found!');
        const installingWorker = registration.installing;
        
        if (installingWorker) {
          installingWorker.addEventListener('statechange', () => {
            console.log('🔄 Installing worker state:', installingWorker.state);
            
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // This is the key - dispatch event with waiting worker info
                console.log('🚀 New worker installed and waiting - dispatching update event');
                const updateEvent = new CustomEvent('onServiceWorkerUpdate', {
                  detail: { registration, waitingWorker: registration.waiting }
                });
                window.dispatchEvent(updateEvent);
              } else {
                console.log('🆕 Content is cached for offline use (first install)');
              }
            }
          });
        }
      };
      
      // Check for existing waiting worker on registration
      if (registration.waiting) {
        console.log('⏳ Found existing waiting worker on registration');
        const updateEvent = new CustomEvent('onServiceWorkerUpdate', {
          detail: { registration, waitingWorker: registration.waiting }
        });
        window.dispatchEvent(updateEvent);
      }
    })
    .catch(error => {
      console.error('❌ Service worker registration failed:', error);
    });
}

function checkValidServiceWorker(swUrl) {
  fetch(swUrl)
    .then(response => {
      const contentType = response.headers.get('content-type');
      if (response.status === 404 || !contentType?.includes('javascript')) {
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl);
      }
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    });
  }
}